import { GAxiosError } from "@/types/errorType";

interface ErrorHandlerOptions<T extends Record<string, string>> {
  error: unknown;
  defaultMessage?: string;
  errorMap?: T;
  shouldMapReason?: boolean;
  context?: string;
}

export function handleAxiosError<T extends Record<string, string>>({
  error,
  defaultMessage = 'Estamos teniendo algunas dificultades técnicas.',
  errorMap,
  shouldMapReason = true,
  context
}: ErrorHandlerOptions<T>): string {
  const err = error as GAxiosError;
  const { reason, message } = err.response?.data || {};
  const shouldUseErrorMap = shouldMapReason && errorMap;
  
  if (shouldUseErrorMap && reason && errorMap) {
    if (context) {
      const contextualKey = `${reason}_${context.toUpperCase()}`;
      if (contextualKey in errorMap) {
        return errorMap[contextualKey];
      }
    }
    
    if (reason in errorMap) {
      return errorMap[reason];
    }
    
    return defaultMessage;
  }

  if (message) {
    return message;
  }

  return defaultMessage;
}